export const merchantWithMultipleStoreStorageKey = 'MERCHANT_WITH_MULTI_STORE';
